import { Injectable } from '@angular/core';
import { EnvironmentDefinition } from "./environment-defination.interface"
import { Environments } from "./environment";

@Injectable()
export class EnvironmentService {

    public currentEnvironment: EnvironmentDefinition;

    constructor() {
        this.currentEnvironment = this.getValidEnvironment();
    }

    private getValidEnvironment(): EnvironmentDefinition {
        return this.determineEnvironmentFromPath();
    }

    private determineEnvironmentFromPath(): EnvironmentDefinition {
        var path = window.location.host.toUpperCase();
        return this.determineEnvironmentFromHost(path);
    }

    private determineEnvironmentFromHost(host: string): EnvironmentDefinition {

        for (var i = 0; i < this.environments.length; i++) {
            var env = this.environments[i];

            for (var j = 0; j < env.hosts.length; j++) {
                var envHost = env.hosts[j].trim().toUpperCase();
                if (host.indexOf(envHost) !== -1) {
                    return env;
                }
            }
        }
        
        // Return LOCAL environment as default when no match is found
        return this.environments.find(env => env.name === 'LOCAL') || this.environments[0];
    }

    private environments: EnvironmentDefinition[] = Environments.environments;

}
